import React from "react";
import FeatherIcon from "components/FeatherIcon";

const CompetitionSelectedMark = () => {
    return (
        <span className={"CompetitionSelectedMark size-[20px] rounded-full flex items-center justify-center bg-brand-yellow"}>
            <FeatherIcon name="check" className={"size-[12px]"} strokeWidth={4} />
        </span>
    );
};

export default CompetitionSelectedMark;
